import {
  CHECK_CONSENT,
  COMMON_SHOW_NOTIFICATION,
  DO_CONSENT,
} from 'redux/actions';
import { IAction, IConsent, INotification } from 'interfaces/common';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ToastType } from 'react-toastify';
import { IDoConsentParams } from 'interfaces/api';
import { Global } from 'constants/main';
import * as publicIp from 'react-public-ip';

const gw_host = '/kgw';
const path_prefix = '/consent-jwt/v1';
const API_KEY = process.env.API_KEY ?? '08AhT8kEWAPyYRWZhWygk8Vv0ZK4dvIi';

const checkConsent = () => {
  const headers = {
    'api-key': API_KEY,
    Authorization: `Bearer ${Global.sockets.wts?.authToken?.accessToken}`,
  };
  return fetch(`${gw_host}${path_prefix}/logged-in/customers/consent`, {
    method: 'GET',
    headers,
  })
    .then((res) => {
      return res.json();
    })
    .catch((error) => console.error({ error }));
};

const regisConsent = async (params: IDoConsentParams) => {
  const userIp = await publicIp
    .v4()
    .then((result: string) => {
      return result;
    })
    .catch((e: Error) => {
      console.error(e);
    });

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Global.sockets.wts?.authToken?.accessToken}`,
      'api-key': API_KEY,
    },
    body: JSON.stringify({ ...params, userIp }),
  };

  return fetch(
    `${gw_host}${path_prefix}/logged-in/customers/consent`,
    requestOptions
  )
    .then((res) => {
      return res.json();
    })
    .catch((error) => console.error({ error }));
};

function* doCheckConsent(request: IAction<undefined>) {
  let isConsent: IConsent;
  try {
    isConsent = yield call(checkConsent);
    yield put({
      type: request.response?.success,
      payload: isConsent.consented != null ? isConsent : undefined,
    });
  } catch (err) {
    yield put({
      type: request.response?.failed,
      payload: [],
    });
  }
}

function* doRegisConsent(request: IAction<IDoConsentParams>) {
  let doConsentResult: IConsent;
  try {
    doConsentResult = yield call(regisConsent, request.payload);
    if (doConsentResult != null && doConsentResult.consented) {
      yield put<IAction<INotification>>({
        type: COMMON_SHOW_NOTIFICATION,
        payload: {
          type: ToastType.SUCCESS,
          title: 'Consent',
          content: 'Confirm successfull',
          time: new Date(),
        },
      });
      yield put({
        type: request.response?.success,
        payload: doConsentResult,
      });
    } else {
      yield put<IAction<INotification>>({
        type: COMMON_SHOW_NOTIFICATION,
        payload: {
          type: ToastType.ERROR,
          title: 'Consent',
          content: 'There are something went wrong',
          time: new Date(),
        },
      });
    }
  } catch (err) {
    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: 'Consent',
        content: 'There are something went wrong, please try again!',
        time: new Date(),
      },
    });
    yield put({
      type: request.response?.failed,
      payload: [],
    });
  }
}

export function* watchcheckConsent() {
  yield takeLatest(CHECK_CONSENT, doCheckConsent);
}

export function* watchRegisConsent() {
  yield takeLatest(DO_CONSENT, doRegisConsent);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Account/Consent.ts